import axios from 'axios';
import { TrackableAsset } from './types';

async function GetTrackableAssetStates(): Promise<TrackableAsset[]> {
  try {
    const { data } = await axios.get(`${process.env.VUE_APP_FLEET_TRACKING_API_URL}/api/v1/tracking/trackable-assets`);

    return data;
  } catch (err: unknown) {
    console.error(err);
    return [];
  }
}

export default {
  GetTrackableAssetStates
};
